export default __webpack_public_path__ + "images/dtdc_logo_2.png";